module.exports = __webpack_public_path__ + "img/house_plan02.96214160.svg";